export default __webpack_public_path__ + "static/media/fanm_dobout.d0f1e2cc.jpg";